import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { Drawer, Switch, Button, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  SaveSubCategoryInfo,
  UpdateSubCategoryInfo,
  checkIfNameNCatgeoryEmpty,
  isActiveTrue,
  returnNullForEmpty,
  subCatgeoryForEdit,
} from "./actions/assetsCategoryService";
import ValidationsMessage from "../../helpers/shared/ValidationsMessage";
import FormInput from "../../helpers/shared/FormInput";
import {
  createAssetSubCategoryTitle,
  editAssetSubCategoryTitle,
} from "../../constants/Constants";
import { retainCursorOnInputChange } from "../Assets/actions/assetsService";

const { Option } = Select;

export default function AssetSubcatgeoryDrawer() {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const AssetCategoryDetail = useSelector(
    (state) => state?.assetsCategoryList?.AssetsCategoryDetail
  );
  const [formData, setFormData] = useState({
    id: null,
    maintenanceMainCategoryId: null,
    name: "",
    active: true,
  });

  const { visible, editRecord } = useSelector((state) => ({
    visible: state?.assetsCategoryList?.subCategoryEdit,
    editRecord: state?.assetsCategoryList?.subCategoryEditRecord,
  }));

  const [isSubmit, setSubmit] = useState(false);

  const selectMainCategory = useCallback((value) => {
    setFormData((prevValues) => {
      return {
        ...prevValues,
        maintenanceMainCategoryId: value,
      };
    });
  }, []);

  useEffect(() => {
    if (!editRecord) {
      setFormData({
        id: null,
        maintenanceMainCategoryId: null,
        name: "",
        active: true,
      });
    } else {
      setFormData({
        id: returnNullForEmpty(editRecord?.sub_category_id),
        name: editRecord?.sub_category_name,
        maintenanceMainCategoryId: editRecord?.main_category_id,
        active: isActiveTrue(editRecord?.sub_category_active),
      });
      selectMainCategory(editRecord?.main_category_id);
    }
  }, [editRecord, selectMainCategory]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
    }
  }, [formData.name, cursorPosition]);

  const assetMainCategory = useMemo(() => {
    return AssetCategoryDetail?.AssetMainCategory || [];
  }, [AssetCategoryDetail]);

  const openDrawer = useCallback(() => {
    dispatch(subCatgeoryForEdit({ isEdit: true, data: null }));
  }, [dispatch]);

  const closeDrawer = useCallback(() => {
    setSubmit(false);
    dispatch(subCatgeoryForEdit({ isEdit: false, data: null }));
    setFormData({
      id: null,
      maintenanceMainCategoryId: null,
      name: "",
      active: true,
    });
  }, [dispatch]);

  const saveCategory = useCallback(() => {
    setSubmit(true);
    if (
      checkIfNameNCatgeoryEmpty(
        formData.name,
        formData.maintenanceMainCategoryId
      )
    )
      return;
    const requestData = {
      ...formData,
      active: formData.active ? 1 : 0,
      name: formData.name.trim(),
    };
    if (!requestData.id) dispatch(SaveSubCategoryInfo(requestData));
    else dispatch(UpdateSubCategoryInfo(requestData));
    closeDrawer();
  }, [dispatch, closeDrawer, formData]);

  return (
    <div className="custom-drawer-wrapper">
      <button
        style={{ margin: "5px 0px" }}
        type="submit"
        onClick={openDrawer}
        className="btn btn-secondary deca-btn-yellow"
        data-testid="create-sub-category-btn"
      >
        Create Sub - Category
      </button>
      <Drawer
        title={
          !!editRecord ? editAssetSubCategoryTitle : createAssetSubCategoryTitle
        }
        placement="right"
        onClose={closeDrawer}
        open={visible}
        style={{ header: { backgroundColor: "#0082c3" }, zIndex: "1040" }}
        footer={
          <div className="col flex-wrapper flex-direction-col">
            <Button
              type="submit"
              className="btn deca-btn-yellow"
              onClick={saveCategory}
            >
              Submit
            </Button>
          </div>
        }
      >
        <div className="form-group">
          <label htmlFor="mainCategorySelect">Main Category Name</label>
          <Select
            className="form-control"
            showSearch
            onChange={selectMainCategory}
            value={formData.maintenanceMainCategoryId}
            placeholder="-- Please Select --"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={!!editRecord}
            id="mainCategorySelect"
          >
            {assetMainCategory?.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
          <ValidationsMessage
            field={formData.maintenanceMainCategoryId}
            isSubmit={isSubmit}
            message="Please Select Main Category"
          />
        </div>
        <div className="col">
          <FormInput
            inputRef={inputRef}
            id={"subcategoryName"}
            label={"Sub Category Name"}
            value={formData.name}
            onChangeHandler={(e) => {
              retainCursorOnInputChange(
                e,
                setFormData,
                formData,
                setCursorPosition,
                "name"
              );
            }}
            validationMessage="Please Enter Sub Category"
            isSubmit={isSubmit}
          />
        </div>
        <div className="col flex-wrapper flex-direction-col width-max-content">
          <label htmlFor="SubcategoryActive">Active</label>
          <Switch
            checkedChildren="Yes"
            onChange={(status) =>
              setFormData((prevValues) => {
                return {
                  ...prevValues,
                  active: status,
                };
              })
            }
            checked={formData.active}
            id="SubcategoryActive"
          />
        </div>
      </Drawer>
    </div>
  );
}
